import axios, { AxiosError } from 'axios';
import log from '../utils/log';

const request = axios.create();

export const handleHttpError = (error: AxiosError) => {
  const { status = 0, data = {}, config = {} }: any = error.response || {};
  const errorCode = data.ErrorCode || 0;

  log.error(
    new Error(
      `STATUS: ${status} | API: ${config.url} | METHOD: ${config.method} | ERROR_CODE: ${errorCode}`,
    ),
    'api-error',
  );

  return Promise.reject({ ...data, status } || error);
};

request.interceptors.response.use(
  (response) => response && response.data,
  handleHttpError,
);

export default request;
